import { shallowEqual, useSelector } from 'react-redux';

import { COUNTRY } from 'src/app/constants/configObjectProperties';
import {
  FEATURE_PAYMENTS_WIDGET_FOR_ALL_NATION,
  useFeatureToggleData,
} from 'src/app/featureToggle';
import { getConfig } from 'src/app/utils/config';
import type AppState from 'src/types/appState';

export const usePaymentsWidgetNation = () => {
  const { advertiserNation } = useSelector(
    (state: AppState) => ({
      advertiserNation: state.session.hirerAccount.nation,
    }),
    shallowEqual,
  );

  const isPaymentWidgetsEnabledForAllNation = useFeatureToggleData(
    FEATURE_PAYMENTS_WIDGET_FOR_ALL_NATION,
    false,
  );

  const paymentWidgetNation =
    isPaymentWidgetsEnabledForAllNation && advertiserNation
      ? advertiserNation
      : getConfig(COUNTRY) ?? 'AU';

  return paymentWidgetNation;
};
